var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinicWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "",
    id: "Capa_1",
    style: {
      enableBackground: "new 0 0 512.036 512.036"
    },
    viewBox: "0 0 512.036 512.036",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "active-path",
    d: "M 503.485 196.551 L 268.818 25.885 c -8.533 -6.4 -17.067 -6.4 -25.6 0 L 8.551 196.551 c -17.067 10.667 -6.4 38.4 12.8 38.4 h 42.667 v 234.667 c 0 12.8 8.533 21.333 21.333 21.333 h 341.333 c 12.8 0 21.333 -8.533 21.333 -21.333 V 234.951 h 42.667 C 509.885 234.951 520.551 207.218 503.485 196.551 Z M 256.018 448.285 c -70.4 0 -128 -57.6 -128 -128 s 57.6 -128 128 -128 s 128 57.6 128 128 S 326.418 448.285 256.018 448.285 Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "active-path",
    points: "288.018,288.285 288.018,224.285 224.018,224.285 224.018,288.285 160.018,288.285 160.018,352.285 224.018,352.285 224.018,416.285 288.018,416.285 288.018,352.285 352.018,352.285 352.018,288.285"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicWhite);
export default __webpack_public_path__ + "static/media/Clinic_WHITE.8f71a33282eea624c817a9a9cd33e3c6.svg";
export { ForwardRef as ReactComponent };